/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { N20, N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { borderRadius } from '@atlassian/jira-common-styles/src/main.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { getErrorHash } from '../utils/error-hash';
import { CodeBlockWithCopyButton } from './code-block-with-actions';

const wrapperStyles = css({
	display: 'inline-block',
	margin: `${token('space.100', '8px')} 0 0`,
	padding: `${token('space.025', '2px')} ${token('space.050', '4px')}`,
	background: token('color.background.accent.gray.subtlest', N20),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius}px`,
	fontFamily: token('font.code'),
	fontSize: token('font.body.small'),
	color: token('color.text.subtlest', N500),
});

const OldErrorHash = ({ error }: { error: Error }) => (
	<div role="note">
		<div css={wrapperStyles}>ERROR: {getErrorHash(error)}</div>
	</div>
);

const NewErrorHash = ({ error }: { error: Error }) => {
	const errorHash = getErrorHash(error);
	const source = `Hash ${errorHash}`;

	return (
		<>
			<FireOperationalAnalytics
				action="rendered"
				actionSubject="errorHash"
				attributes={{
					errorHash,
				}}
			/>
			<div role="note">
				<CodeBlockWithCopyButton source={source} copyCodeActionSubjectId="copyErrorHash" />
			</div>
		</>
	);
};

export const ErrorHash = componentWithFG(
	'trace_id_in_jira_error_flag_and_page',
	NewErrorHash,
	OldErrorHash,
);
